// @ts-nocheck
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { URL } from '../../service/Service';


const Multibanco = ({
                        value,
                        formReplies,
                        fixedValue,
                        itemPurchases,
                        donations,
                        email,
                        onEmailChange,
                    }) => {

    const [error, setError] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const navigate = useNavigate();


    const paymentErrorMessage =
        'Não foi possível iniciar o pagamento com Multibanco. Tente novamente ou escolha outro método.';

    const paymentUnavailableMessage =
        'Multibanco não está disponível para este formulário. Por favor, selecione outro método de pagamento.';


    /*
     * Identifica a resposta do backend quando
     * o método não está disponível no canal.
     */
    const isPaymentMethodUnavailable = (
        responseStatus,
        responseText,
        result,
    ) => {

        if (responseStatus === 503) {
            return true;
        }

        const rawMessage = [
            responseText,
            result?.message,
            result?.error,
            result?.detail,
        ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();

        return (
            rawMessage.includes('método de pagamento selecionado não está disponível')
            || rawMessage.includes('metodo de pagamento selecionado nao esta disponivel')
            || rawMessage.includes('método de pagamento não está disponível')
            || rawMessage.includes('metodo de pagamento nao esta disponivel')
            || rawMessage.includes('payment method unavailable')
            || rawMessage.includes('paymentmethodunavailable')
        );
    };


    const handleFetch = async () => {

        if (isSubmitting || !isChecked) {
            return;
        }


        const normalizedEmail =
            String(email || '').trim();


        if (!normalizedEmail) {

            setError(
                'Introduza o seu email.'
            );

            return;
        }


        setIsSubmitting(true);
        setError('');


        try {

            const body = {

                value,

                email: normalizedEmail,

                fixedValue,

                itemPurchases,

                donations,

                formID: formReplies.formID,

                replyFields: formReplies.replyFields,

                /*
                 * IP público obtido no FormReader.
                 */
                ip: formReplies?.ip || '',

            };


            const response = await fetch(
                `${URL}/api/payment/multibanco`,
                {
                    method: 'POST',

                    headers: {
                        accept: 'application/json',
                        'content-type': 'application/json',
                    },

                    body: JSON.stringify(body),
                }
            );


            const responseText =
                await response.text();


            let result = {};


            if (responseText) {

                try {

                    result =
                        JSON.parse(responseText);

                } catch (_error) {

                    result = {};

                }
            }


            /*
             * =====================================================
             * MULTIBANCO NÃO DISPONÍVEL
             * =====================================================
             */
            if (
                !response.ok
                && isPaymentMethodUnavailable(
                    response.status,
                    responseText,
                    result,
                )
            ) {

                setError(
                    paymentUnavailableMessage
                );

                return;
            }


            /*
             * Outros erros.
             */
            if (!response.ok) {

                setError(
                    paymentErrorMessage
                );

                return;
            }


            /*
             * Pagamento criado corretamente.
             */
            navigate(
                '/clientforms/success/mb',
                {
                    state: {
                        paymentinfo: result,
                        formId: formReplies.formID,
                    },
                }
            );


        } catch (_error) {

            setError(
                paymentErrorMessage
            );

        } finally {

            setIsSubmitting(false);

        }
    };


    return (

        <div className="mt-5">

            {/* ===================================================
          EMAIL
          =================================================== */}
            <label
                htmlFor="email-multibanco"
                className="mb-2 block text-sm font-bold"
                style={{
                    color: 'var(--form-text)',
                }}
            >
                Email
            </label>


            <input
                id="email-multibanco"
                type="email"
                name="email-multibanco"
                autoComplete="email"
                placeholder="Insira o seu Email"
                required
                value={email || ''}
                onChange={onEmailChange}
                disabled={isSubmitting}
                className="
          block
          w-full
          rounded-xl
          border
          border-gray-300
          bg-white
          p-2.5
          text-sm
          text-gray-900
          outline-none
          transition
          focus:border-green-cl
          focus:ring-2
          focus:ring-green-cl/20
          disabled:cursor-not-allowed
          disabled:opacity-60
        "
                style={{
                    backgroundColor: '#ffffff',
                    color: '#111827',
                }}
            />


            {/* ===================================================
          CONSENTIMENTO
          =================================================== */}
            <label
                htmlFor="multibanco-consent"
                className="
          mt-6
          flex
          cursor-pointer
          items-start
          gap-3
          rounded-xl
          border
          p-4
          text-sm
        "
                style={{
                    color: 'var(--form-text)',
                    borderColor: 'var(--form-border)',
                    background: 'var(--form-surface)',
                }}
            >

                <input
                    id="multibanco-consent"
                    type="checkbox"
                    checked={isChecked}
                    disabled={isSubmitting}
                    onChange={(event) =>
                        setIsChecked(
                            event.target.checked
                        )
                    }
                    className="
            mt-0.5
            h-4
            w-4
            rounded
            border-gray-300
            text-green-cl
            focus:ring-green-cl
            disabled:cursor-not-allowed
            disabled:opacity-60
          "
                />


                <span>
          Tomei conhecimento que a informação constante deste formulário é guardada e tratada pela Eupago e dou consentimento para tal.
        </span>

            </label>


            {/* ===================================================
          ERRO / MÉTODO INDISPONÍVEL
          =================================================== */}
            {error && (

                <div
                    role="alert"
                    className="
            mt-4
            rounded-xl
            border
            border-red-200
            bg-red-50
            p-4
          "
                >

                    <p
                        className="
              text-sm
              font-semibold
              text-red-700
            "
                    >
                        {error}
                    </p>

                </div>

            )}


            {/* ===================================================
          FINALIZAR
          =================================================== */}
            <div className="flex justify-end">

                <button
                    type="button"
                    onClick={handleFetch}
                    disabled={
                        !isChecked
                        || isSubmitting
                        || !String(email || '').trim()
                    }
                    className="
            mt-6
            inline-flex
            w-full
            items-center
            justify-center
            rounded-xl
            bg-green-cl
            px-5
            py-3
            font-semibold
            text-white
            transition
            hover:bg-opacity-90
            disabled:cursor-not-allowed
            disabled:opacity-50
          "
                >

                    {
                        isSubmitting
                            ? 'A processar...'
                            : 'Finalizar'
                    }

                </button>

            </div>

        </div>
    );
};


export default Multibanco;